module.exports = __webpack_public_path__ + "images/controllers/import/import-example-deals.png";